module.exports = __webpack_public_path__ + "static/media/revicons.04eb8fc5.woff";